import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import RideServices from '../components/RideServices';
import ReferralLookup from '../components/ReferralLookup';
import Footer from '../components/Footer';

function HomePage() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <RideServices />
        <section className="section referral-section" id="referrals" aria-labelledby="referrals-heading">
          <div className="section__inner referral-section__inner">
            <div className="section__head">
              <p className="eyebrow">Drivers</p>
              <h2 id="referrals-heading">Already approved? Look up your referral code</h2>
              <p className="section__lead">
                Enter the mobile number on your driver profile to view your code.
              </p>
            </div>
            <ReferralLookup />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;
